/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomGrid, BootstrapDialog, CustomInfosForm } from '../../../../assets/style/globalStyle';
import '../../../../assets/style/privacy.css';
import { isMobile } from 'react-device-detect';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import { selectLogin, selectTypeClient, selectClient } from '../../../../store/login/loginSlice';
import {
  Stack,
  Typography,
  Button,
  Card,
  Grid,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Box,
  Snackbar,
  Fade,
  Link,
  Stepper,
  Step,
  StepLabel,
  Divider
} from '@mui/material';

import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing,
  Selection
} from 'devextreme-react/data-grid';

import configAxios from '../../../../services/configAxios';
import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import AddEditDeclarationHealth from './AddDeclarationHealth';
import DocumentsForSignature from './DocumentsForSignature';
import { useDebounce } from 'use-debounce';

import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import DownloadDocumentsSigning from './DownloadDocumentsSigning';
import Demo from '../../../components/multiplesComponents/Demo';
import ShowDocuments from '../../../components/multiplesComponents/ShowDocuments';
import {
  getMainSteps,
  resolveActiveMainStep,
  canAdvanceMainStep,
  isDeclarationCompleted
} from './signatureWizardSteps.jsx';

const allowedPageSizes = [5, 10, 20, 30];

const signature = (props) => {
  const URL_AWS_S3 = 'https://mplansistemas-vendaonline.s3.sa-east-1.amazonaws.com';
  const video = `${URL_AWS_S3}/homolog/assets/video/instrucao.mp4`;

  const [rowSelected, setRowSelected] = useState();
  const [openModalDeclarationHealth, setOpenModalDeclarationHealth] = useState(false);
  const [showDeclaration, setShowDeclaration] = useState(false);

  const [modalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [modalInstructions, setModalInstructions] = useState(false);

  const infoStateTemp = useSelector(selectLogin);
  const typeClient = useSelector(selectTypeClient);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const company = useSelector(selectClient);

  const [infosClients, setInfosClients] = useState([{ statusvenda: '' }]);
  const infosPJ = useRef({ statusvenda: '', nomefantasia: '', codclient: '' });
  const infosPF = useRef({ statusvenda: '', nome: '', codclient: '' });

  const [infosQuestions, setInfosQuestions] = useState([]);
  const [responseQuestions, setResponseQuestions] = useState([]);
  const [url] = useState(URL_AWS_S3);
  const [urlDocument, setUrlDocument] = useState(null);

  const [documentsSigning, setDocumentsSigning] = useState({});
  const [OpenModalShowDocument, setOpenModalShowDocument] = useState(false);

  const [buttonSign, setButtonSign] = useState(false);
  const [buttonDownload, setButtonDownload] = useState(false);

  const [activeMainStep, setActiveMainStep] = useState(0);
  const [activeSubStepDeclaracao, setActiveSubStepDeclaracao] = useState(0);
  const [activeSubStepAssinatura, setActiveSubStepAssinatura] = useState(0);
  const [documentsForSign, setDocumentsForSign] = useState([]);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  // Alias para compatibilidade (stepper e código que ainda referenciem activeStep)
  const activeStep = activeMainStep;
  const hasAnySignedDocument = Array.isArray(documentsSigning) && documentsSigning.length > 0;

  const user = useSelector((state) => state.login.authenticatedUser);
  let tpbenef = useSelector((state) => state.login.type);
  const isRespJur = typeClient === 'resp_jur';

  const blockStatus = ['Aberta', 'Análise', 'Rejeitada', 'Negada', 'Cancelada pelo proponente'];

  const navigation = useNavigate();
  const client = useSelector((state) => state.login.clientLogin);
  const routerLogout = `/portal/${client}`;

  const key = useRef('');
  const lastSignatureData = useRef(null);
  const [value] = useDebounce(key.current, 1000);

  /**info
   * id_type_client === 1 - Físico
   * id_type_client === 2 - Júridico
   *
   */

  useEffect(() => {
    getInfosclients();
    getInfosQuestions();
    getDocumentsSigning();

    setPrivacyOpen(true);
  }, []);

  function rejectAccess() {
    navigation(routerLogout);
  }

  function functionUpdateKey() {
    key.current = Math.random();
  }

  async function getInfosclients() {
    const router =
      infoState.id_type_client === 1
        ? `/clients/getInfosSignaturePF/${infoState.id_client}`
        : `/clients/getInfosSignaturePJ/${infoState.id_client}/${infoState.id}/${typeClient}`;

    return configAxios
      .get(router)
      .then((result) => {
        if (blockStatus.includes(result.data.client.statusvenda)) {
          rejectAccess();
        }
        if (infoState.id_type_client === 1) {
          infosPF.current = result.data.client;
          setInfosClients(result.data.health);

          if (result.data.client.statusvenda !== 'Aprovada') {
            setButtonSign(true);
          }

          if (result.data.client.statusvenda === 'Aprovada') {
            setButtonDownload(true);
          }
        }
        if (infoState.id_type_client === 2) {
          infosPJ.current = result.data.client;
          setInfosClients(result.data.health);

          if (infoState.tpcontrat === '2-COLETIVO EMPRESARIAL') {
            if (result.data.client.statusvenda !== 'Aprovada') {
              setButtonSign(true);
            }

            if (result.data.client.statusvenda === 'Aprovada') {
              setButtonDownload(true);
            }
          }
        }
        const status = result.data.client?.statusvenda || '';
        const sign =
          infoState.id_type_client === 1
            ? status !== 'Aprovada'
            : (isRespJur || infoState.tpcontrat === '2-COLETIVO EMPRESARIAL') &&
              status !== 'Aprovada';
        const download =
          infoState.id_type_client === 1
            ? status === 'Aprovada'
            : (isRespJur || infoState.tpcontrat === '2-COLETIVO EMPRESARIAL') &&
              status === 'Aprovada';
        const savedStepRaw = result.data.client?.current_step;
        const savedSubstepRaw = result.data.client?.current_substep;
        const savedStep = savedStepRaw == null ? 0 : savedStepRaw;
        const savedSubstep =
          result.data.client.statusvenda === 'Aguardando CPT(s)' ? 0 : savedSubstepRaw;
        const mainStep = resolveActiveMainStep(savedStep, {
          buttonSign: sign,
          buttonDownload: download,
          isRespJur
        });
        setActiveMainStep(mainStep);
        const healthList = result.data.health || [];
        if (mainStep === 0 && typeof savedSubstep === 'number' && savedSubstep >= 0) {
          setActiveSubStepDeclaracao(Math.min(savedSubstep, Math.max(0, healthList.length - 1)));
        }
        if (mainStep === 1 && typeof savedSubstep === 'number' && savedSubstep >= 0) {
          setActiveSubStepAssinatura(savedSubstep);
        }
        lastSignatureData.current = result.data;
        getDocumentsForSignatureFetch(result.data);
        return result.data;
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as informações, por favor, tente novamente!',
          'Atenção'
        );
        return null;
      });
  }

  function getDocumentsForSignatureFetch(data) {
    if (data?.client) {
      lastSignatureData.current = data;
    }
    const tpcontrat = user?.userLoggedIn?.[0]?.tpcontrat;
    const titbenef = user?.userLoggedIn?.[0]?.titbenef ?? 'undefined';
    const id_dep = user?.userLoggedIn?.[0]?.id;
    const codplano = user?.userLoggedIn?.[0]?.codplano;
    const id_client = user?.userLoggedIn?.[0]?.id_client;
    const id_sindicato = user?.userLoggedIn?.[0]?.id_association;
    const allow_additive = user?.userLoggedIn?.[0]?.allow_additive;
    const status_venda =
      user?.userLoggedIn?.[0]?.statusvenda || data?.client?.statusvenda || data?.status_venda;
    const onDocumentsError = () => {
      NotificationManager.warning(
        'Tivemos dificuldades para buscar os documentos para assinatura, tente novamente!',
        'Atenção'
      );
    };

    if (!user) return;

    if (tpcontrat) {
      const payload = {
        tpcontrat,
        id_client,
        codplano,
        status_venda
      };
      if (status_venda === 'Aguardando cliente' || status_venda === 'Aguardando CPT(s)') {
        payload.tpbenef = tpbenef;
        payload.titbenef = titbenef;
        payload.id_dep = id_dep;
        payload.id_sindicato = id_sindicato;
        payload.allow_additive = allow_additive;
        payload.included_resp =
          user.userLoggedIn[0].cpf_cnpj === user.userLoggedIn[0].cpf_cnpj_resp ? 'S' : 'N';
      }
      configAxios
        .post('/signing/getDocumentsForSignature', payload)
        .then((result) => setDocumentsForSign(result.data || []))
        .catch(onDocumentsError);
    } else if (data?.client) {
      const payload = {
        tpcontrat: data.client.tpcontrat,
        id_client: data.client.id,
        statusvenda: data.client.statusvenda,
        status_venda: data.client.statusvenda,
        id_profile: user.userLoggedIn[0].id_profile,
        codplano: data.client.codplano ?? codplano
      };
      configAxios
        .post('/signing/getDocumentsForSignature', payload)
        .then((result) => setDocumentsForSign(result.data || []))
        .catch(onDocumentsError);
    } else {
      setDocumentsForSign([]);
    }
  }

  useEffect(() => {
    if (user && lastSignatureData.current) {
      getDocumentsForSignatureFetch(lastSignatureData.current);
    }
  }, [user]);

  useEffect(() => {
    if (activeMainStep === 0 && infosClients.length > 0 && infosClients[0].statusvenda !== '') {
      const idx = Math.min(activeSubStepDeclaracao, infosClients.length - 1);
      setRowSelected(infosClients[idx] ?? infosClients[0]);
    }
  }, [activeMainStep, activeSubStepDeclaracao, infosClients]);

  useEffect(() => {
    if (
      activeMainStep === 1 &&
      documentsForSign.length > 0 &&
      activeSubStepAssinatura >= documentsForSign.length
    ) {
      setActiveSubStepAssinatura(Math.max(0, documentsForSign.length - 1));
    }
  }, [activeMainStep, documentsForSign.length, activeSubStepAssinatura]);

  async function getInfosQuestions() {
    await configAxios
      .get('/questions/listQuestions')
      .then((response) => {
        setInfosQuestions(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as informações, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function RenderHealth(infos) {
    if (infos.data.data.completedhealthdeclaration) {
      return 'Sim';
    }
    return 'Não';
  }

  function isDocumentSignedForStep(document) {
    if (!document || !documentsSigning || typeof documentsSigning.length === 'undefined') {
      return false;
    }

    if (user?.userLoggedIn?.[0]?.id_profile === 3) {
      return documentsSigning.some(
        (signed) => document.tpdoc === signed.tpdoc && document.id_dep === signed.id_dep
      );
    }

    if (
      (company === 'fenix' && user?.userLoggedIn?.[0]?.id_profile === 1) ||
      user?.userLoggedIn?.[0]?.id_profile === 2
    ) {
      if (document.tpdoc === 'Aditivo dependente' && document.id_dep === null) {
        return documentsSigning.some((signed) => document.tpdoc === signed.tpdoc);
      }
      return documentsSigning.some(
        (signed) => document.tpdoc === signed.tpdoc && document.id_dep === signed.id_dep
      );
    }

    if (document.tpdoc === 'Aditivo dependente' && document.id_dep === null) {
      return documentsSigning.some((signed) => document.tpdoc === signed.tpdoc);
    }

    return documentsSigning.some((signed) => document.tpdoc === signed.tpdoc);
  }

  function addDeclarationHealthModal() {
    if (!rowSelected) {
      NotificationManager.warning(
        'Selecione o beneficiário para preencher a declaração de saúde!',
        'Atenção'
      );
      return;
    }
    if (isDeclarationCompleted(rowSelected)) {
      NotificationManager.warning(
        'Declaração já preenchida, selecione o botão visualizar para visualizar a declaração!',
        'Atenção'
      );
      return;
    }
    setOpenModalDeclarationHealth(true);
  }

  function showDeclarationHealthModal() {
    if (!rowSelected) {
      NotificationManager.warning(
        'Selecione o beneficiário para visualizar a declaração de saúde!',
        'Atenção'
      );
      return;
    }

    if (!isDeclarationCompleted(rowSelected)) {
      NotificationManager.warning(
        'Declaração ainda não preenchida, selecione o botão preencher para preenche-la!',
        'Atenção'
      );
      return;
    }
    getResponsesQuestions();
    setShowDeclaration(true);
    setOpenModalDeclarationHealth(true);
  }

  function saveWizardStep(step, substep = 0) {
    const id_client = infoState.id_client;
    if (id_client == null) return Promise.resolve();
    return configAxios
      .post('/clients/wizardProgress', {
        id_client,
        current_step: step,
        current_substep: substep
      })
      .catch(() => {
        NotificationManager.warning(
          'Não foi possível salvar o progresso da etapa agora. Tente novamente em instantes.',
          'Atenção'
        );
      });
  }

  function getDocumentsSigning() {
    const tpcontrat = user.userLoggedIn[0].tpcontrat;
    let client = {};

    if (user.userLoggedIn[0].cpf_cnpj === user.userLoggedIn[0].cpf_cnpj_resp) {
      client = {
        userLoggedIn: { ...user.userLoggedIn[0] },
        tpcontrat: tpcontrat,
        tpbenef: tpbenef,
        included_resp: 'S',
        status_venda: user.userLoggedIn[0].tpcontrat
      };
    } else {
      client = {
        userLoggedIn: { ...user.userLoggedIn[0] },
        tpcontrat: tpcontrat,
        tpbenef: tpbenef,
        included_resp: 'N',
        status_venda: user.userLoggedIn[0].tpcontrat
      };
    }
    configAxios
      .post(`/signing/getDocumentsSigning`, client)
      .then((result) => {
        setDocumentsSigning(result.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar os documentos assinados, tente novamente!',
          'Atenção'
        );
      });
  }

  async function getResponsesQuestions(optionalRow) {
    const row = optionalRow ?? rowSelected;
    if (!row) return;
    const flag = row.flag ? 'tb_clients' : 'tb_clients_dep';
    const id = flag === 'tb_clients' ? infoState.id_client : row.id;

    const router =
      infoState.id_type_client === 1
        ? `/questions/getResponsesQuestionsPF/${id}/${flag}`
        : `/questions/getResponsesQuestionsPJ/${row.id}`;

    await configAxios
      .get(router)
      .then((response) => {
        setResponseQuestions(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as informações, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function openContractForS3() {
    let contract;

    contract =
      infosPF.current.codcont !== null ? infosPF.current.codcont : infoState.codcontrato_plano;

    if (infoState.id_type_client === 2) {
      contract =
        infosPJ.current.codcont !== null ? infosPJ.current.codcont : infoState.codcontrato_plano;
    }
    setUrlDocument(`${url}/${company}/assets/contracts/${contract}.pdf`);

    setOpenModalShowDocument(true);
  }

  function ButtonShowContract() {
    if (infoState.tpcontrat === '1-INDIVIDUAL/FAMILIAR') {
      return (
        <>
          {(typeClient === 'resp_jur' || infoState.titbenef === 'S') &&
            infoState.tipo === 'Complexo' && (
              <Button
                variant="contained"
                color="ligth"
                onClick={() => {
                  openContractForS3();
                }}
                sx={
                  isMobile
                    ? { mb: 1, textTransform: 'none', mr: 2, mt: 1 }
                    : { ml: 1, textTransform: 'none' }
                }
                startIcon={<Iconify icon="eva:file-text-outline" />}>
                Visualizar contrato
              </Button>
            )}
        </>
      );
    }

    if (infoState.tpcontrat === '2-COLETIVO EMPRESARIAL' && infoState.tipooperacao !== 'Odonto') {
      return (
        <>
          {(typeClient === 'resp_jur' ||
            user.userLoggedIn[0].cpf_cnpj === user.userLoggedIn[0].cpf_cnpj_resp) &&
            infoState.tipo === 'Complexo' && (
              <Button
                variant="contained"
                color="ligth"
                onClick={() => {
                  openContractForS3();
                }}
                sx={
                  isMobile
                    ? { mb: 1, textTransform: 'none', mr: 1, mt: 1 }
                    : { ml: 1, textTransform: 'none' }
                }
                startIcon={<Iconify icon="eva:file-text-outline" />}>
                Visualizar contrato
              </Button>
            )}
        </>
      );
    }
  }

  function RenderButttonShowDeclarationOfHealth() {
    if (
      typeClient !== 'resp_jur' &&
      infoState.tipooperacao !== 'Odonto' &&
      (infosPF.current.odontologico === 'Não' || infosPJ.current.odontologico === 'Não')
    ) {
      return (
        <>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="end"
            sx={{ mb: 2 }}
            data-tut="reactour__preencher">
            <Button
              variant="contained"
              color="primary"
              onClick={showDeclarationHealthModal}
              sx={{ mr: 1, textTransform: 'none' }}
              startIcon={<MonitorHeartIcon />}>
              Visualizar
            </Button>
            <ButtonsActions />
          </Stack>
        </>
      );
    }
  }

  function ButtonsActions() {
    if (
      (infoState.tpbenef === 'Titular' ||
        infoState.titbenef === 'S' ||
        infoState.tpbenef === 'Titular menor') &&
      (infosPJ.current.statusvenda === 'Aguardando cliente' ||
        infosPF.current.statusvenda === 'Aguardando cliente') &&
      !documentsSigning.length
    ) {
      return (
        <>
          {infoState.entrevisqualificada === 'Não' && (
            <>
              <Button
                variant="contained"
                color="success"
                onClick={addDeclarationHealthModal}
                sx={{ textTransform: 'none' }}
                startIcon={<Iconify icon="eva:edit-fill" />}>
                Preencher
              </Button>
              {infoState.excluirdeclaracaosaude !== 'Não' && (
                <Button
                  onClick={() => {
                    openModalDeleteDeclarationHealth(true);
                  }}
                  color="error"
                  variant="contained"
                  sx={{ ml: 1 }}
                  startIcon={<Iconify icon="eva:trash-2-outline" />}>
                  Excluir
                </Button>
              )}
            </>
          )}
          {infoState.analisemedica === 'Sim' && (
            <>
              <Button
                variant="contained"
                color="success"
                onClick={addDeclarationHealthModal}
                sx={{ textTransform: 'none' }}
                startIcon={<Iconify icon="eva:edit-fill" />}>
                Preencher
              </Button>
              {infoState.excluirdeclaracaosaude !== 'Não' && (
                <Button
                  onClick={() => {
                    openModalDeleteDeclarationHealth(true);
                  }}
                  color="error"
                  variant="contained"
                  sx={{ ml: 1 }}
                  startIcon={<Iconify icon="eva:trash-2-outline" />}>
                  Excluir
                </Button>
              )}
            </>
          )}
        </>
      );
    }
  }

  function RenderStatus() {
    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="start"
        sx={isMobile ? { mb: 2, mt: 2 } : { mt: 2, ml: 1 }}>
        {infoState.id_type_client === 1 && (
          <Grid container>
            <Grid item xs={12}>
              <CustomInfosForm>Código da venda: #{infosPF.current.codclient}</CustomInfosForm>
            </Grid>
            <Grid item xs={12}>
              <CustomInfosForm>
                Status atual:{' '}
                {infosPF.current.statusvenda === 'Aguardando CPT(s)'
                  ? 'Aguardando CPT(s) - (Cobertura parcial temporária)'
                  : infosPF.current.statusvenda}
              </CustomInfosForm>
            </Grid>
          </Grid>
        )}
        {infoState.id_type_client === 2 && (
          <Grid container>
            <Grid item xs={12}>
              <CustomInfosForm>Código da venda: #{infosPJ.current.codclient}</CustomInfosForm>
            </Grid>
            <Grid item xs={12}>
              <CustomInfosForm>
                Status atual:{' '}
                {infosPJ.current.statusvenda === 'Aguardando CPT(s)'
                  ? 'Aguardando CPT(s) - (Cobertura parcial temporária)'
                  : infosPJ.current.statusvenda}
              </CustomInfosForm>
            </Grid>
          </Grid>
        )}
      </Stack>
    );
  }

  function openModalDeleteDeclarationHealth() {
    if (!rowSelected) {
      NotificationManager.warning(
        'Selecione o beneficiário para excluir a declaração de saúde!',
        'Atenção'
      );
      return;
    }

    if (!isDeclarationCompleted(rowSelected)) {
      NotificationManager.warning(
        'Declaração ainda não preenchida, selecione o botão preencher para preenche-la!',
        'Atenção'
      );
      return;
    }

    setModalDeleteOpen(true);
  }

  function selectedRow(event) {
    setRowSelected(event.selectedRowsData[0]);
  }

  function HandleDeleteDeclarationHealth() {
    const flag = rowSelected.flag ? 'tb_clients' : 'tb_clients_dep';
    configAxios
      .delete(
        `/questions/deleteResponseDeclarationHealth/${rowSelected.id}/${flag}/${rowSelected.id_client}`
      )
      .then(() => {
        setModalDeleteOpen(false);
        getInfosclients(infoState);
        key.current = Math.random();
        NotificationManager.success('Declaração de saúde excluída com sucesso!', 'Sucesso');
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para excluir a declaração de saúde, tente novamente!',
          'Atenção'
        );
      });
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setPrivacyOpen(false);
  };
  const action = (
    <>
      <Button color="primary" variant="contained" size="small" onClick={handleClose}>
        Prosseguir
      </Button>
    </>
  );
  const link = (
    <>
      Ao prosseguir com a assinatura dos documentos, você aceita os termos expressos e estipulados e
      dá como verdadeira a sua assinatura eletrônica, conforme RN (resolução normativa) Nº 413, cujo
      texto pode ser conferido no diário oficial da união
      <Link
        href="https://www.in.gov.br/web/dou/-/resolucao-normativa-rn-n-413-de-11-de-novembro-de-2016-24504005"
        underline="none"
        target="_blank"
        rel="noopener">
        {' '}
        clicando aqui.
      </Link>
    </>
  );

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };

  return (
    <RenderPage title="Assinaturas e declarações de saúde">
      {infoState.tipotela === 'Nova' && (
        <>
          <Snackbar
            open={privacyOpen}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={20000}
            TransitionComponent={Fade}
            onClose={handleClose}
            message={link}
            action={action}
            ContentProps={{
              sx: {
                background: '#FFFFFF',
                color: 'black',
                borderRadius: '10px'
              }
            }}
          />
          <div>
            <BootstrapDialog
              onClose={() => {
                setModalInstructions(false);
              }}
              aria-labelledby="customized-dialog-title"
              fullWidth
              maxWidth={'md'}
              PaperProps={{
                sx: { borderRadius: 0 }
              }}
              open={modalInstructions}>
              <BootstrapDialogTitle
                id="customized-dialog-title"
                onClose={() => {
                  setModalInstructions(false);
                }}>
                Instruções para preenchimento e assinatura de documentos
              </BootstrapDialogTitle>
              <DialogContent dividers>
                <video src={video} width="100%" height="100%" controls></video>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setModalInstructions(false);
                  }}
                  color="error"
                  variant="contained"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Fechar
                </Button>
              </DialogActions>
            </BootstrapDialog>
          </div>
          <div>
            <BootstrapDialog
              onClose={() => {
                setModalDeleteOpen(false);
                getInfosclients(infoState);
              }}
              aria-labelledby="customized-dialog-title"
              fullWidth
              maxWidth={'sm'}
              PaperProps={{
                sx: { borderRadius: 0 }
              }}
              open={modalDeleteOpen}>
              <BootstrapDialogTitle
                id="customized-dialog-title"
                onClose={() => {
                  setModalDeleteOpen(false);
                }}>
                Excluir declaração de saúde
              </BootstrapDialogTitle>

              <DialogContent dividers>
                <Typography variant="subtitle2">
                  Deseja realmente excluir a declaração de saúde?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  onClick={() => {
                    HandleDeleteDeclarationHealth();
                  }}
                  color="success"
                  startIcon={<Iconify icon="eva:checkmark-circle-2-fill" />}>
                  Sim
                </Button>
                <Button
                  onClick={() => {
                    setModalDeleteOpen(false);
                    getInfosclients(infoState);
                  }}
                  color="error"
                  variant="contained"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Não
                </Button>
              </DialogActions>
            </BootstrapDialog>
          </div>
          <AddEditDeclarationHealth
            openModal={openModalDeclarationHealth}
            setOpenModal={setOpenModalDeclarationHealth}
            showDeclaration={showDeclaration}
            setShowDeclaration={setShowDeclaration}
            responseQuestions={responseQuestions}
            functionGrid={getInfosclients}
            functionUpdateKey={functionUpdateKey}
            infosAskQuestions={infosQuestions}
            rowSelected={rowSelected}
            controlaMudancaCarencia={infoState.controlamudancacarencia}
            statusvenda={
              infosPJ.current.statusvenda !== '' && typeClient !== 'resp_jur'
                ? infosPJ.current.statusvenda
                : infosClients[0].statusvenda
            }
          />
          <ShowDocuments
            openModal={OpenModalShowDocument}
            url={urlDocument}
            setOpenModal={setOpenModalShowDocument}
          />

          {isMobile && (
            <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
              <Stack>
                <Demo
                  tpbenef={tpbenef}
                  tipooperacao={infoState.tipooperacao}
                  entrevisqualificada={infoState.entrevisqualificada}
                />
              </Stack>
            </Stack>
          )}
          <Stack direction="row" alignItems="center" justifyContent="start" mb={0}>
            <Grid container>
              <BreadcrumbsNav {...props} sx={{ mr: 2 }} />
              {!isMobile && (
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Typography variant="h4" gutterBottom>
                    {infoState.tipooperacao !== 'Cartão' && infoState.tipooperacao !== 'Odonto'
                      ? 'Assinaturas e declarações de saúde'
                      : 'Assinatura de documentos'}
                  </Typography>
                </Grid>
              )}
              {isMobile &&
                infoState.tipooperacao !== 'Cartão' &&
                infoState.tipooperacao !== 'Odonto' && (
                  <>
                    <Grid item xs={12} sx={{ mt: 1 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Utilize as opções abaixo para preencher as declarações e assinar todos os
                        documentos
                      </Typography>
                    </Grid>
                    {/* <Alert severity="info">
                  Prezado(a), não se esqueça de preencher as declarações de saúde e assinar todos os
                  documentos!
                </Alert> */}
                  </>
                )}
              {isMobile &&
                (infoState.tipooperacao === 'Cartão' || infoState.tipooperacao === 'Odonto') && (
                  <Grid item xs={12} sx={{ mt: 1 }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Utilize as opções abaixo para assinar todos os documentos
                    </Typography>
                  </Grid>
                )}

              {!isMobile &&
                infoState.tipooperacao !== 'Cartão' &&
                infoState.tipooperacao !== 'Odonto' && (
                  <>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" gutterBottom>
                        Utilize as opções abaixo para preencher as declarações de saúde e assinar os
                        documentos
                      </Typography>
                    </Grid>
                    {/* <Alert severity="info">
                  Prezado(a), não se esqueça de preencher as declarações de saúde e assinar todos os
                  documentos!
                </Alert> */}
                  </>
                )}
              {!isMobile &&
                (infoState.tipooperacao === 'Cartão' || infoState.tipooperacao === 'Odonto') && (
                  <>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" gutterBottom>
                        Utilize as opções abaixo assinar todos os documentos!
                      </Typography>
                    </Grid>
                  </>
                )}
            </Grid>
            {!isMobile && (
              <>
                <Stack>
                  <Demo
                    tpbenef={tpbenef}
                    tipooperacao={infoState.tipooperacao}
                    entrevisqualificada={infoState.entrevisqualificada}
                  />
                </Stack>
              </>
            )}
          </Stack>
          <Stepper activeStep={activeMainStep} sx={{ pt: 2, pb: 2 }}>
            {getMainSteps(buttonDownload).map((step) => (
              <Step key={step.id}>
                <StepLabel>{step.label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box sx={{ minHeight: 320 }}>
            {activeMainStep === 0 && (
              <Card variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                {infosClients.length > 0 && infosClients[0].statusvenda !== '' ? (
                  <Stack spacing={3}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} md={6}>
                        <Stack spacing={0.5}>
                          <Typography variant="body2" color="text.secondary">
                            Código da venda: #
                            {infoState.id_type_client === 1
                              ? infosPF.current.codclient
                              : infosPJ.current.codclient}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Status atual:{' '}
                            {infoState.id_type_client === 1
                              ? infosPF.current.statusvenda === 'Aguardando CPT(s)'
                                ? 'Aguardando CPT(s) - (Cobertura parcial temporária)'
                                : infosPF.current.statusvenda
                              : infosPJ.current.statusvenda === 'Aguardando CPT(s)'
                              ? 'Aguardando CPT(s) - (Cobertura parcial temporária)'
                              : infosPJ.current.statusvenda}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
                        <Stack spacing={0.5} alignItems={{ xs: 'flex-start', md: 'flex-end' }}>
                          <Typography variant="h6" fontWeight={600}>
                            Declaração de Saúde
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Beneficiário {activeSubStepDeclaracao + 1} de {infosClients.length}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>

                    <Divider />

                    {(() => {
                      const beneficiary = infosClients[activeSubStepDeclaracao];
                      if (!beneficiary) return null;
                      const showDeclarationActions =
                        !isRespJur &&
                        infoState.tipooperacao !== 'Cartão' &&
                        infoState.tipooperacao !== 'Odonto' &&
                        (infosPF.current.odontologico === 'Não' ||
                          infosPJ.current.odontologico === 'Não');
                      const isCompleted = isDeclarationCompleted(beneficiary);
                      const canExcluir =
                        showDeclarationActions &&
                        infoState.excluirdeclaracaosaude !== 'Não' &&
                        !hasAnySignedDocument &&
                        isCompleted;

                      return (
                        <Stack spacing={3}>
                          <Stack spacing={1} data-tut="reactour__iso">
                            <Typography variant="subtitle1" fontWeight={600}>
                              {beneficiary.nome}
                            </Typography>
                            {!isMobile && (
                              <Stack
                                direction="row"
                                spacing={2}
                                divider={<Divider orientation="vertical" flexItem />}
                                flexWrap="wrap">
                                <Typography variant="body2" color="text.secondary">
                                  CPF: {beneficiary.cpf_cnpj}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  Tipo: {beneficiary.tpbenef || '-'}
                                </Typography>
                              </Stack>
                            )}
                            {showDeclarationActions && (
                              <Typography
                                variant="body2"
                                sx={{
                                  color: isCompleted ? 'success.main' : 'text.secondary',
                                  fontWeight: 500
                                }}>
                                {isCompleted ? 'Declaração preenchida' : 'Declaração pendente'}
                              </Typography>
                            )}
                          </Stack>

                          {showDeclarationActions && (
                            <Stack
                              direction="row"
                              spacing={2}
                              flexWrap="wrap"
                              sx={{ pt: 1 }}
                              data-tut="reactour__preencher">
                              <Button
                                variant="contained"
                                size="medium"
                                onClick={addDeclarationHealthModal}
                                startIcon={<MonitorHeartIcon />}
                                sx={{ textTransform: 'none', minWidth: 120 }}>
                                Preencher
                              </Button>
                              {isCompleted && (
                                <Button
                                  variant="outlined"
                                  size="medium"
                                  onClick={() => {
                                    setRowSelected(beneficiary);
                                    getResponsesQuestions(beneficiary).then(() => {
                                      setShowDeclaration(true);
                                      setOpenModalDeclarationHealth(true);
                                    });
                                  }}
                                  startIcon={<Iconify icon="eva:eye-outline" />}
                                  sx={{ textTransform: 'none', minWidth: 120 }}>
                                  Visualizar
                                </Button>
                              )}
                              {canExcluir && (
                                <Button
                                  variant="outlined"
                                  color="error"
                                  size="medium"
                                  onClick={() => {
                                    setRowSelected(beneficiary);
                                    openModalDeleteDeclarationHealth();
                                  }}
                                  startIcon={<Iconify icon="eva:trash-2-outline" />}
                                  sx={{ textTransform: 'none', minWidth: 100 }}>
                                  Excluir
                                </Button>
                              )}
                            </Stack>
                          )}
                        </Stack>
                      );
                    })()}
                  </Stack>
                ) : (
                  <>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Stack spacing={0.5}>
                          <Typography variant="body2" color="text.secondary">
                            Código da venda: #
                            {infoState.id_type_client === 1
                              ? infosPF.current.codclient
                              : infosPJ.current.codclient}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Status atual:{' '}
                            {infoState.id_type_client === 1
                              ? infosPF.current.statusvenda
                              : infosPJ.current.statusvenda}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      align="center"
                      sx={{ py: 4 }}>
                      Nenhum beneficiário encontrado.
                    </Typography>
                  </>
                )}
              </Card>
            )}
            {activeMainStep === 1 && (
              <Card variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                <Stack spacing={3}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                      <Stack spacing={0.5}>
                        <Typography variant="h6" fontWeight={600}>
                          Assinatura de documentos
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Assine os documentos pendentes no botão abaixo.
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
                      <Stack spacing={0.5} alignItems={{ xs: 'flex-start', md: 'flex-end' }}>
                        {documentsForSign.length > 0 && (
                          <Typography variant="body2" color="text.secondary">
                            Documento {activeSubStepAssinatura + 1} de {documentsForSign.length}
                          </Typography>
                        )}
                      </Stack>
                    </Grid>
                  </Grid>

                  <Divider />

                  <Stack direction="row" alignItems="center" flexWrap="wrap" gap={2}>
                    <ButtonShowContract />
                    {buttonSign === true && (
                      <>
                        {documentsForSign.length > 0 ? (
                          <Box
                            component="span"
                            data-tut="reactour__assinar"
                            sx={{ display: 'inline-flex' }}>
                            <DocumentsForSignature
                              functionGrid={getInfosclients}
                              getDocumentsSigning={getDocumentsSigning}
                              infosClients={infosClients}
                              infosPJ={infosPJ}
                              infosPF={infosPF}
                              documentsFromParent={documentsForSign}
                              currentDocumentIndex={activeSubStepAssinatura}
                            />
                          </Box>
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            Nenhum documento pendente para assinatura. Avance para o próximo passo.
                          </Typography>
                        )}
                      </>
                    )}
                    {!buttonSign && (
                      <Typography variant="body2" color="success.main" fontWeight={500}>
                        Assinaturas concluídas.
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </Card>
            )}
            {activeMainStep === 2 && (
              <Card sx={{ p: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Download dos documentos
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Baixe os documentos já assinados.
                </Typography>
                {buttonDownload === true && (
                  <DownloadDocumentsSigning
                    infosClients={infosClients}
                    infosPJ={infosPJ}
                    tipo={
                      infosPJ.current.tpcontrat_client
                        ? infosPJ.current.tpcontrat_client
                        : infosPF.current.tpcontrat_client
                    }
                  />
                )}
                {!buttonDownload && (
                  <Typography variant="body2" color="text.secondary">
                    Nenhum documento disponível para download no momento.
                  </Typography>
                )}
              </Card>
            )}
          </Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mt: 2, mb: 2 }}>
            {!isRespJur && !(activeMainStep === 1 && hasAnySignedDocument) && (
              <Button
                disabled={activeMainStep === 0 && activeSubStepDeclaracao === 0}
                onClick={() => {
                  if (activeMainStep === 0 && activeSubStepDeclaracao > 0) {
                    const nextSub = activeSubStepDeclaracao - 1;
                    setActiveSubStepDeclaracao(nextSub);
                    saveWizardStep(0, nextSub);
                    return;
                  }
                  if (activeMainStep === 1 && activeSubStepAssinatura > 0) {
                    const nextSub = activeSubStepAssinatura - 1;
                    setActiveSubStepAssinatura(nextSub);
                    saveWizardStep(1, nextSub);
                    return;
                  }
                  const prev = activeMainStep - 1;
                  setActiveMainStep(prev);
                  if (prev === 0) {
                    const sub = infosClients.length - 1 || 0;
                    setActiveSubStepDeclaracao(sub);
                    saveWizardStep(prev, sub);
                  } else if (prev === 1) {
                    const sub = documentsForSign.length - 1 || 0;
                    setActiveSubStepAssinatura(sub);
                    saveWizardStep(prev, sub);
                  } else {
                    saveWizardStep(prev, 0);
                  }
                }}
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            )}
            <Box data-tut="reactour__avancar">
              {activeMainStep < getMainSteps(buttonDownload).length - 1 ||
              (activeMainStep === 1 && activeSubStepAssinatura < documentsForSign.length - 1) ? (
                <Button
                  variant="contained"
                  onClick={() => {
                    const ctx = {
                      infosClients,
                      buttonSign,
                      buttonDownload,
                      tipooperacao: infoState.tipooperacao,
                      isRespJur
                    };
                    const ok = (list) => {
                      const c = list ? { ...ctx, infosClients: list } : ctx;
                      const check = canAdvanceMainStep(activeMainStep, c);
                      if (!check.allowed) {
                        NotificationManager.warning(
                          check.message || 'Conclua esta etapa para avançar.',
                          'Atenção'
                        );
                        return false;
                      }
                      return true;
                    };
                    if (activeMainStep === 0) {
                      getInfosclients().then((data) => {
                        const health = Array.isArray(data?.health) ? data.health : infosClients;
                        // Só valida "todos preenchidos" ao sair de Declarações (último sub-step)
                        if (activeSubStepDeclaracao < health.length - 1) {
                          const nextSub = activeSubStepDeclaracao + 1;
                          setActiveSubStepDeclaracao(nextSub);
                          saveWizardStep(0, nextSub);
                          return;
                        }
                        if (!ok(health)) return;
                        setActiveSubStepDeclaracao(0);
                        setActiveMainStep(1);
                        setActiveSubStepAssinatura(0);
                        saveWizardStep(1, 0);
                      });
                      return;
                    }
                    if (activeMainStep === 1) {
                      const currentDocument = documentsForSign[activeSubStepAssinatura];
                      const documentSigned = isDocumentSignedForStep(currentDocument);
                      if (currentDocument && !documentSigned) {
                        NotificationManager.warning(
                          'É necessário assinar o documento atual antes de avançar.',
                          'Atenção'
                        );
                        return;
                      }

                      if (activeSubStepAssinatura < documentsForSign.length - 1) {
                        const nextSub = activeSubStepAssinatura + 1;
                        setActiveSubStepAssinatura(nextSub);
                        saveWizardStep(1, nextSub);
                      } else {
                        if (!ok()) return;
                        setActiveSubStepAssinatura(0);
                        if (buttonDownload) {
                          setActiveMainStep(2);
                          saveWizardStep(2, 0);
                        }
                      }
                    }
                  }}
                  startIcon={<Iconify icon="eva:arrow-forward-fill" />}>
                  Próximo
                </Button>
              ) : null}
            </Box>
          </Stack>
        </>
      )}
      {infoState.tipotela !== 'Nova' && (
        <>
          <Snackbar
            open={privacyOpen}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={20000}
            TransitionComponent={Fade}
            onClose={handleClose}
            message={link}
            action={action}
            ContentProps={{
              sx: {
                background: '#FFFFFF',
                color: 'black',
                borderRadius: '10px'
              }
            }}
          />
          <div>
            <BootstrapDialog
              onClose={() => {
                setModalInstructions(false);
              }}
              aria-labelledby="customized-dialog-title"
              fullWidth
              maxWidth={'md'}
              PaperProps={{
                sx: { borderRadius: 0 }
              }}
              open={modalInstructions}>
              <BootstrapDialogTitle
                id="customized-dialog-title"
                onClose={() => {
                  setModalInstructions(false);
                }}>
                Instruções para preenchimento e assinatura de documentos
              </BootstrapDialogTitle>
              <DialogContent dividers>
                <video src={video} width="100%" height="100%" controls></video>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setModalInstructions(false);
                  }}
                  color="error"
                  variant="contained"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Fechar
                </Button>
              </DialogActions>
            </BootstrapDialog>
          </div>
          <div>
            <BootstrapDialog
              onClose={() => {
                setModalDeleteOpen(false);
                getInfosclients(infoState);
              }}
              aria-labelledby="customized-dialog-title"
              fullWidth
              maxWidth={'sm'}
              PaperProps={{
                sx: { borderRadius: 0 }
              }}
              open={modalDeleteOpen}>
              <BootstrapDialogTitle
                id="customized-dialog-title"
                onClose={() => {
                  setModalDeleteOpen(false);
                }}>
                Excluir declaração de saúde
              </BootstrapDialogTitle>

              <DialogContent dividers>
                <Typography variant="subtitle2">
                  Deseja realmente excluir a declaração de saúde?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  onClick={() => {
                    HandleDeleteDeclarationHealth();
                  }}
                  color="success"
                  startIcon={<Iconify icon="eva:checkmark-circle-2-fill" />}>
                  Sim
                </Button>
                <Button
                  onClick={() => {
                    setModalDeleteOpen(false);
                    getInfosclients(infoState);
                  }}
                  color="error"
                  variant="contained"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Não
                </Button>
              </DialogActions>
            </BootstrapDialog>
          </div>
          <AddEditDeclarationHealth
            openModal={openModalDeclarationHealth}
            setOpenModal={setOpenModalDeclarationHealth}
            showDeclaration={showDeclaration}
            setShowDeclaration={setShowDeclaration}
            responseQuestions={responseQuestions}
            functionGrid={getInfosclients}
            functionUpdateKey={functionUpdateKey}
            infosAskQuestions={infosQuestions}
            rowSelected={rowSelected}
            controlaMudancaCarencia={infoState.controlamudancacarencia}
            statusvenda={
              infosPJ.current.statusvenda !== '' && typeClient !== 'resp_jur'
                ? infosPJ.current.statusvenda
                : infosClients[0].statusvenda
            }
          />
          <ShowDocuments
            openModal={OpenModalShowDocument}
            url={urlDocument}
            setOpenModal={setOpenModalShowDocument}
          />

          {isMobile && (
            <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
              <Stack>
                <Demo
                  tpbenef={tpbenef}
                  tipooperacao={infoState.tipooperacao}
                  entrevisqualificada={infoState.entrevisqualificada}
                />
              </Stack>
            </Stack>
          )}
          <Stack direction="row" alignItems="center" justifyContent="start" mb={0}>
            <Grid container>
              <BreadcrumbsNav {...props} sx={{ mr: 2 }} />
              {!isMobile && (
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Typography variant="h4" gutterBottom>
                    {infoState.tipooperacao !== 'Cartão' && infoState.tipooperacao !== 'Odonto'
                      ? 'Assinaturas e declarações de saúde'
                      : 'Assinatura de documentos'}
                  </Typography>
                </Grid>
              )}
              {isMobile &&
                infoState.tipooperacao !== 'Cartão' &&
                infoState.tipooperacao !== 'Odonto' && (
                  <>
                    <Grid item xs={12} sx={{ mt: 1 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Utilize as opções abaixo para preencher as declarações e assinar todos os
                        documentos
                      </Typography>
                    </Grid>
                    {/* <Alert severity="info">
                  Prezado(a), não se esqueça de preencher as declarações de saúde e assinar todos os
                  documentos!
                </Alert> */}
                  </>
                )}
              {isMobile &&
                (infoState.tipooperacao === 'Cartão' || infoState.tipooperacao === 'Odonto') && (
                  <Grid item xs={12} sx={{ mt: 1 }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Utilize as opções abaixo para assinar todos os documentos
                    </Typography>
                  </Grid>
                )}

              {!isMobile &&
                infoState.tipooperacao !== 'Cartão' &&
                infoState.tipooperacao !== 'Odonto' && (
                  <>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" gutterBottom>
                        Utilize as opções abaixo para preencher as declarações de saúde e assinar os
                        documentos
                      </Typography>
                    </Grid>
                    {/* <Alert severity="info">
                  Prezado(a), não se esqueça de preencher as declarações de saúde e assinar todos os
                  documentos!
                </Alert> */}
                  </>
                )}
              {!isMobile &&
                (infoState.tipooperacao === 'Cartão' || infoState.tipooperacao === 'Odonto') && (
                  <>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" gutterBottom>
                        Utilize as opções abaixo assinar todos os documentos!
                      </Typography>
                    </Grid>
                  </>
                )}
            </Grid>
            {!isMobile && (
              <>
                <Stack>
                  <Demo
                    tpbenef={tpbenef}
                    tipooperacao={infoState.tipooperacao}
                    entrevisqualificada={infoState.entrevisqualificada}
                  />
                </Stack>
              </>
            )}
          </Stack>
          <Stack
            data-tut="reactour__assinar"
            direction="row"
            alignItems="center"
            justifyContent="end"
            sx={isMobile ? { mb: 2, mt: 2 } : { mb: 2 }}>
            <ButtonShowContract />
            {buttonSign === true && (
              <DocumentsForSignature
                functionGrid={getInfosclients}
                getDocumentsSigning={getDocumentsSigning}
                infosClients={infosClients}
                infosPJ={infosPJ}
                infosPF={infosPF}
                key={value}
              />
            )}
            {buttonDownload === true && (
              <DownloadDocumentsSigning
                infosClients={infosClients}
                infosPJ={infosPJ}
                tipo={
                  infosPJ.current.tpcontrat_client
                    ? infosPJ.current.tpcontrat_client
                    : infosPF.current.tpcontrat_client
                }
              />
            )}
          </Stack>
          <Card>
            <CustomGrid data-tut="reactour__iso">
              <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200', p: 2 }}>
                <RenderStatus />
                {infoState.tipooperacao !== 'Cartão' && infoState.tipooperacao !== 'Odonto' && (
                  <RenderButttonShowDeclarationOfHealth />
                )}
                <DataGrid
                  dataSource={infosClients}
                  showBorders={true}
                  remoteOperations={true}
                  wordWrapEnabled={true}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  onSelectionChanged={selectedRow}>
                  <Selection mode="single" />
                  <Column dataField="nome" caption="Nome" />
                  {!isMobile && <Column dataField="cpf_cnpj" caption="Cpf" />}
                  {!isMobile && <Column dataField="tpbenef" caption="Tipo de beneficiário" />}
                  {!isMobile && <Column dataField="email" caption="Email" />}
                  {infoState.tipooperacao !== 'Cartão' &&
                    infoState.tipooperacao !== 'Odonto' &&
                    (infosPF.current.odontologico === 'Não' ||
                      infosPJ.current.odontologico === 'Não') && (
                      <Column
                        dataField="completedhealthdeclaration"
                        caption="Declaração preenchida"
                        cellRender={(data) => <RenderHealth data={data} />}
                      />
                    )}
                  <SearchPanel visible={true} width={240} placeholder="Procurar..." />
                  {!isMobile && (
                    <GroupPanel
                      visible={true}
                      emptyPanelText="Arraste as colunas aqui para agrupar"
                    />
                  )}
                  <Scrolling rowRenderingMode="virtual"></Scrolling>
                  <Paging defaultPageSize={30} />
                  <Pager
                    visible={true}
                    allowedPageSizes={allowedPageSizes}
                    showPageSizeSelector={true}
                    showInfo={true}
                    showNavigationButtons={true}
                  />
                  <ColumnChooser
                    enabled={true}
                    title={'Escolher uma coluna'}
                    emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                  />
                  <ColumnFixing enabled={true} />
                  <HeaderFilter visible={true} allowSearch={true} />
                </DataGrid>
              </Box>
            </CustomGrid>
          </Card>
        </>
      )}
    </RenderPage>
  );
};

export default signature;
